module.exports = __webpack_public_path__ + "img/italy-male.8497644d.png";